import { render, staticRenderFns } from "./AsyncItems.vue?vue&type=template&id=3115d309&"
import script from "./AsyncItems.vue?vue&type=script&lang=js&"
export * from "./AsyncItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports